// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX
import * as React from 'react';
import { updateKeyword } from './actions/app-actions';
import 'url-search-params-polyfill';
import { IAutocompleteResults, fetchAutoCompleteResults, DefaultAutoCompleteResults } from './objects/autocomplete';
import { Autocomplete } from './autocomplete';
interface ISearchBoxProps {
    searchTerm: { Text: string, Value: string },
    dispatch: any,
    onChange: Function,
    suggestion: string,
}

interface ISearchBoxState {
    autoCompleteResults: IAutocompleteResults,
}

export class SearchBox extends React.Component<ISearchBoxProps, ISearchBoxState>{
    private searchBoxInput: HTMLInputElement;

    constructor(props) {
        super(props);
        this.state = {
            autoCompleteResults: DefaultAutoCompleteResults
        }
    }


    render() {
        return (
            <div className="sidebar-search">
                <p><strong>You searched for "<span className="highlightClass">{this._termCleanup(this.props.searchTerm.Text)}</span>"</strong></p>
                <h3>Search</h3>
                <form className="ea-search-input" onSubmit={this._onSubmit.bind(this)}>
                    <div className="input-button-container">
                        <input
                            type="search"
                            ref={(el) => { this.searchBoxInput = el; }}
                            onChange={(e) => this.onInputChange(e.currentTarget.value)}
                            onKeyDown={this.onInputKeyDown} />
                        <button type="submit" className="ea-search-icon-btn">
                            <svg className="ea-svg-icon icon-search" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-search" />' }}></svg>
                            <span className="visually-hidden">Search</span>
                        </button>
                        {this.renderAutocomplete()}
                    </div>
                    {this.props.suggestion &&
                        <div className="search-suggestion">Did you mean <a href="#" className="search-suggestion-link" onClick={() => this.onSearch(this.props.suggestion)}>{this.props.suggestion}</a>?
                        </div>}
                </form>
            </div>
        );
    }

    renderAutocomplete = () => {
        const { autoCompleteResults } = this.state;
        let searchText = this.searchBoxInput ? this.searchBoxInput.value : '';

        if (!autoCompleteResults.isActive || !searchText || searchText.length < 3 || autoCompleteResults.hits.length === 0) {
            return;
        }

        return (
            <Autocomplete
                autocompleteResults={this.state.autoCompleteResults}
                searchTerm={searchText}
                onResultClick={this.AutocompleteResultClicked}
                onResultActive={this.setAutoCompleteActiveHit}
                onMouseLeave={() => this.setAutoCompleteActiveHit(-1)}
            />
        );
    }

    _onSubmit(event) {
        event.preventDefault();

        this.onSearch(this.searchBoxInput.value);
    }

    _termCleanup(term: string) {
        if (!term) return term;

        if (term.match(/\\"/)) {
            term = term.replace(/\\"/g, '"');
        }
        if (term.match(/\\'/)) {
            term = term.replace(/\\'/g, "'");
        }

        return term;
    }

    onInputChange = (term: string) => {
        if (term.length > 2) {
            fetchAutoCompleteResults(term)
                .then((data) => {
                    let results = { ...DefaultAutoCompleteResults }

                    if (data) {
                        results.activeHit = -1;
                        results.hits = data;
                        results.isActive = true;
                    }
                    this.setState({
                        autoCompleteResults: results
                    });
                })

            this.setAutoCompleteActive(true);
        }
        else {
            if (this.state.autoCompleteResults.isActive) {
                this.setAutoCompleteActive(false);
            }
        }
    }

    onSearch = (value: string) => {
        this.setSearchInputValue(value);
        let keywordValue = value.replace(/\"/g, '\\"').replace(/\'/g, "\\'");
        this.props.dispatch(this.props.dispatch(updateKeyword([{ Text: keywordValue, Value: keywordValue }])));
        let search = location.search;
        let params = new URLSearchParams(search);
        params.set('q', keywordValue);
        let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + params.toString().replace(/\+/g, '%20');
        window.history.replaceState({ path: newUrl }, '', newUrl);
        if (typeof (this.props.onChange) === 'function') {
            this.props.onChange();
        }
    }

    setSearchInputValue = (value: string) => {
        this.searchBoxInput.value = value.replace(/\\/g, '/');

    }

    AutocompleteResultClicked = (value: string) => {
        this.setAutoCompleteActiveHit(-1);
        this.setAutoCompleteActive(false);

        this.onSearch(value);
    }

    setAutoCompleteActive = (value: boolean) => {
        let results = { ...this.state.autoCompleteResults }
        results.isActive = value;
        results.activeHit = -1;

        this.setState({
            autoCompleteResults: results
        });
    }

    setAutoCompleteActiveHit = (index: number) => {
        let results = { ...this.state.autoCompleteResults }
        results.activeHit = index;

        this.setState({
            autoCompleteResults: results
        });
    }

    /// <summary>
    /// Intercepts special keys that handle autocomplete scrolling and selection
    /// </summary>
    onInputKeyDown = (e) => {
        const { autoCompleteResults } = this.state;

        switch (e.keyCode) {
            //Up arrow
            //Move selected autocomplete result up one
            case 38: {
                e.preventDefault();
                if (autoCompleteResults.activeHit == -1) {
                    this.setAutoCompleteActiveHit(autoCompleteResults.hits.length - 1);
                } else {
                    this.setAutoCompleteActiveHit(autoCompleteResults.activeHit - 1);
                }
                break;
            }

            //Down arrow
            //Move selected autocomplete result down one
            case 40: {
                e.preventDefault();
                if (autoCompleteResults.activeHit == autoCompleteResults.hits.length - 1)
                    this.setAutoCompleteActiveHit(-1);
                else
                    this.setAutoCompleteActiveHit(autoCompleteResults.activeHit + 1);
                break;
            }

            //Enter key
            //If an autocomplete option is selected, change the search text to that, otherwise submit
            case 13: {
                let term = this.searchBoxInput ? this.searchBoxInput.value : '';

                if (autoCompleteResults.activeHit > -1) {
                    term = this.state.autoCompleteResults.hits[this.state.autoCompleteResults.activeHit].Query;
                    this.setSearchInputValue(term);
                    this.setAutoCompleteActiveHit(-1);
                }

                this.setAutoCompleteActive(false);
                this.onSearch(term);
            }
        }
    }
}